export default __webpack_public_path__ + "static/simple-bar-403beff4bf65a7848cc2b3744779cca7.png";